<template>
  <media-display
    class="c-mini-cart-media"
    v-bind="mediaDisplayProps"
  />
</template>

<script>
import MediaDisplay from '../mediaDisplay/MediaDisplay'
export default {
  components: {
    MediaDisplay
  },
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    mediaDisplayProps() {
      return {
        media: this.media,
        forceMobile: true
      }
    },
    media() {
      const product = this.product
      return product.media
    }
  }
}
</script>

<style lang="scss" scoped>
.c-mini-cart-media {
}
</style>
